export default __webpack_public_path__ + "static/media/mentorSentEmail.a2ff8561.svg";